import React, { useState, useEffect } from "react";
import classNames from "classnames";
import { Droppable, Draggable } from "react-beautiful-dnd";
import { throttle } from "lodash";
import { FormattedMessage } from "react-intl";

import "./style.scss";

import DicesMenu from "../DicesMenu";
import DicesProduct from "../DicesProduct";
import WasteBasket from "../../WasteBasket";

import { useMainContext } from "../../../store/Context";
import { useShowItemsInSection } from "../../../hooks/useShowItemsInSection";

import DicesService from "services/DicesService";

const SizeData = {};

const DicesSlider = () => {
  const [ items ] = useState(DicesService.getDices());

  const { fromShowRef: heading, itemShow, updateShow } = useShowItemsInSection({
    querySelector: ".DicesSlider__slide",
  });
  const context = useMainContext();
  const [state, setState] = useState({
    total: 0,
    itemActive: 0,
    scrollPosition: null,
  });

  const sliders = [];

  const handleShowAlert = () => {
    context.setShowAlert(0);
  };
  const handleThrottled = throttle(handleShowAlert, 4000);

  const handlerSelectCategory = (index) => {
    setState({ ...state, total: index, itemActive: index });
  };

  useEffect(() => {
    context.isMobile && setState({ ...state, itemActive: itemShow });
  }, [itemShow]);

  const handleClasses = (snapshot, dice) => {
    const classes = classNames("Item", {
      isDragging: snapshot.isDragging,
      notDragging: !snapshot.isDragging,
      isTassel: dice.category_type === "tassel",
      disabled: !dice.stock,
    });
    return classes;
  };

  const handleAddDice = (dice) => {
    if (!dice.stock) {
      return;
    }

    if (
      context.product.dices.reduce(
        (total, { category_type }) =>
          category_type === "leatherletter" ? total + 1 : total,
        0
      ) >= 2 &&
      dice.category_type === "leatherletter"
    ) {
      context.setShowAlert(2);
      return;
    }

    if (context.product.dices.length < 6) {
      context.addDice(dice);
    } else {
      handleThrottled();
    }
  };

  const handleOnClick = (dice) => {
    if (context.isMobile) {
      handleAddDice(dice);
    }
  };

  const onTouchStart = (element) => {
      const touch = element.touches[0];
      setState({...state, scrollPosition: touch});
  };

  const onTouchEnd = (element, dice) => {
      const touch = element.changedTouches[0];
      if (
          element.currentTarget
            .querySelector(".Item")
            .classList.contains("isDragging") &&
          touch.clientY === state.scrollPosition.clientY
      ) {
          handleAddDice(dice);
      }
  };

  useEffect(() => {
    var drop;
    const acceleration = 100;
    // var timeRemoveDiceInfo;
    const onScroll = (event) => {
      event.preventDefault();
      const { deltaY } = event;
      if (!drop) return;
      let left = drop.scrollLeft;

      if (deltaY < 0) {
        // up
        drop.scrollTo(left - acceleration, 0);
      } else {
        // down
        drop.scrollTo(left + acceleration, 0);
      }
      // clearTimeout(timeRemoveDiceInfo);
      return false;
    };
    if (heading.current) {
      drop = heading.current.querySelector(".DicesSlider-Drop");
      heading.current.addEventListener("wheel", onScroll, false);
    }
    return () => {
      heading.current &&
        heading.current.removeEventListener("wheel", onScroll, false);
    };
  }, []);

  const { itemActive } = state;
  const sliderClasses = classNames("DicesSlider", {
    mobile: context.isMobile,
  });

  const handlerOnGetSize = (index, height, maxHeightCells) => {
    if (SizeData[index] && SizeData[index].timer)
      clearTimeout(SizeData[index].timer);
    if (SizeData[index] && SizeData[index].ready) return;

    !SizeData[index] && (SizeData[index] = { height: 0, maxHeightCells });
    SizeData[index].height < height && (SizeData[index].height = height);

    SizeData[index].timer = setTimeout(() => {
      const cells = Math.ceil(200 / SizeData[index].height);
      const MAX_CELLS = SizeData[index].maxHeightCells || 3;
      const el = document.querySelectorAll(".DicesSlider__slide")[index];
      if (!el) return;
      el.style.gridTemplateRows = `repeat(${
        cells < MAX_CELLS ? cells : MAX_CELLS
      }, auto)`;
      SizeData[index].ready = true;
    }, 200);
  };

  const handlerZIndex = (snapshot) => {
    if (!snapshot.draggingFromThisWith) {
      const el = document.querySelector(".Dices");
      el && (el.style.zIndex = 10);
    }
  };

  return (
    <>
      <WasteBasket />
      <p className="DiceSliderTitle">
        <FormattedMessage id="App.dice" />
      </p>
      <DicesMenu
        items={items}
        handleOnClick={handlerSelectCategory}
        itemActive={itemActive}
      />

      <div className={sliderClasses} ref={heading}>
        <div className="DicesSlider-DiceInfo"></div>
        <Droppable droppableId="dices" isDropDisabled>
          {(provided, snapshot) => (
            <div
              className="DicesSlider-Drop"
              ref={provided.innerRef}
              onScroll={() => updateShow()}
            >
              {handlerZIndex(snapshot)}
              <div className="DicesSlider-Drop-Scroll"></div>
              {items
                .filter(({ dices }) => dices.length)
                .map((item, itemIndex) => (
                  <div
                    ref={(input) => {
                      sliders[itemIndex] = input;
                    }}
                    className="DicesSlider__slide"
                    key={itemIndex}
                  >
                    {item.dices.map((dice, index) => (
                      <Draggable
                        key={index}
                        draggableId={`${item.title}-${index}`}
                        index={index}
                        isDragDisabled={!dice.stock}
                      >
                        {(provided, snapshot) => (
                          <div className={"DicesProductWrapper"}>
                            <button
                              type="button"
                              onTouchStart={(e) => {
                                onTouchStart(e);
                              }}
                              onTouchEnd={(element) => {
                                onTouchEnd(element, dice);
                              }}
                              onClick={() => handleOnClick(dice)}
                            >
                              <div
                                className={classNames("ItemWrapper", {
                                  tassel: dice.category_type === "tassel",
                                })}
                              >
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  className={handleClasses(snapshot, dice)}
                                >
                                  <DicesProduct
                                    dice={dice}
                                    className={"DicesProduct"}
                                    key={`DicesProduct-${index}`}
                                    setSize={({ height, maxHeightCells }) =>
                                      handlerOnGetSize(
                                        itemIndex,
                                        height,
                                        maxHeightCells
                                      )
                                    }
                                  />
                                </div>
                                {snapshot.isDragging && (
                                  <div className="DraggingItem">
                                    <DicesProduct
                                      dice={dice}
                                      className={"DicesProduct"}
                                      key={`DicesProduct-${index}`}
                                    />
                                  </div>
                                )}
                              </div>
                            </button>
                          </div>
                        )}
                      </Draggable>
                    ))}
                  </div>
                ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </div>
    </>
  );
};

export default DicesSlider;
